import Vue from 'vue'
import Router from 'vue-router'

import Auth from '@/common/auth'

import Template from '@/template/index'
import Home from '@/views/home'
import Authorized from '@/views/authorized'
import TrocarEscola from '@/views/trocarescola'
import TesteRealizar from '@/views/testerealizar'
import AcessoNegado from '@/views/acessonegado'
import ContratarConfirmacao from '@/views/contratarconfirmacao'

import routersgenerated from './generated'

Vue.use(Router)


let childrens = routersgenerated.concat([
    {
        path: 'home',
        name: 'Home',
        component: Home
    },
    {
        path: 'colaborador/details/:id',
        name: 'Detalhes Colaboradores / Candidatos',
        component: function (resolve) { require(['@/views/colaborador/details'], resolve) }
    },
    {
        path: 'iniciarprocessoseletivo',
        name: 'Iniciar Processo Seletivo',
        component: function (resolve) { require(['@/views/iniciarprocessoseletivo'], resolve) }
    },
    {
        path: 'candidato',
        name: 'Candidatos',
        component: function (resolve) { require(['@/views/candidato'], resolve) }
    },
]);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/authorized',
            name: 'authorized',
            component: Authorized,
        },
        {
            path: '/trocarescola',
            name: 'trocarescola',
            component: TrocarEscola,
        },
        {
            path: '/acessonegado',
            name: 'acessonegado',
            component: AcessoNegado,
        },
        {
            path: '/teste-realizar/:candidatoId/:testeId',
            name: 'testerealizar',
            component: TesteRealizar,
        },
        {
            path: '/teste-realizar/:candidatoId/:testeId/:cpf',
            name: 'testerealizarcpf',
            component: TesteRealizar,
        },
        {
            path: '/contratar-confirmacao/:chaveAcesso',
            name: 'contratarconfirmacao',
            component: ContratarConfirmacao,
        },
        {
            path: '/',
            redirect: '/home',
            component: Template,
            meta: { requiresAuth: true },
            children: childrens
        },

    ]
})

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {

        if (!Auth.logged()) {
            Auth.login(true);
            return;
        }

        if (!Auth.canAccess(to.path)) {
            next('/acessonegado')
            return;
        }
    }
    next();
});


export default router;
